<div class="support-shell">

    <!-- Topbar — mirrors main-layout .toolbar -->
    <div class="support-topbar">
        @if (isLoggedIn) {
            <a routerLink="/home" class="support-back-link">
                <i class="ri-arrow-left-line"></i>
                <img src="assets/images/tmeic_logo_inverted.svg" alt="TMEIC" class="support-logo" />
            </a>
        } @else {
            <img src="assets/images/tmeic_logo_inverted.svg" alt="TMEIC" class="support-logo" />
        }
        <div class="support-topbar-actions">
            <a routerLink="/privacy-policy" class="support-login-btn">Privacy Policy</a>
            @if (!isLoggedIn) {
                <a routerLink="/login" class="support-login-btn">Login</a>
            }
        </div>
    </div>

    <!-- Content — mirrors main-layout .content -->
    <div class="support-content">
        <div class="sp-page">

            <!-- Page Header -->
            <div class="sp-header">
                <h1 class="sp-title">Support</h1>
            </div>

            <!-- Need Help Card -->
            <div class="sp-card">
                <div class="sp-card-hdr">
                    <h2 class="sp-section-heading">Need Help?</h2>
                </div>
                <div class="sp-card-section sp-card-section--last">
                    <p class="sp-section-label">Contact our support team:</p>
                    <p class="sp-section-value">Navigator-support&#64;tmeic.com</p>
                </div>
            </div>

            <!-- Common Topics Card -->
            <div class="sp-card">
                <div class="sp-card-section sp-card-section--last">
                    <h3 class="sp-section-heading">Common Topics:</h3>
                    <ul class="sp-topics">
                        <li class="sp-topic-item">Access issues &rarr; Contact support team</li>
                        <li class="sp-topic-item">App not loading &rarr; Check network connection</li>
                        <li class="sp-topic-item">Missing project data &rarr; Contact project team</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
